// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"359":"141d3e2b2b61ad324558","815":"69767a34324a10c21c54"}[chunkId] + ".js";
};